"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const referAFriendInputs = [
  {
    name: "variant",
    type: "string",
    enum: [
      { label: "Refer a friend", value: "raf" },
      { label: "How it works", value: "hiw" },
    ],
    defaultValue: "hiw",
    friendlyName: "Component Variant",
    required: true,
  },
  {
    name: "header",
    type: "string",
    showIf: 'options.get("variant") === "raf"',
    friendlyName: "Header Text",
    defaultValue: "Refer a friend",
    required: true,
  },
  {
    name: "title",
    type: "string",
    friendlyName: "Main Title",
    defaultValue: "How does it work?",
    required: true,
  },
  {
    name: "subtitle",
    type: "string",
    friendlyName: "Subtitle",
    defaultValue:
      "Invite your friends* to try Ploom and they will get £10 off their first Starter Bundle purchase.  For every friend who uses your code. You will receive £20 to spend on your next online purchase of refills or accessories.",
    required: true,
  },
  {
    name: "subtitleDetails",
    type: "string",
    showIf: 'options.get("variant") === "hiw"',
    friendlyName: "Details",
    defaultValue:
      "*Friends must be smokers or vapers 18 years or older who have never ordered from the Ploom website. Read the refer a friend terms & conditions.",
  },
  {
    name: "registerUrl",
    type: "url",
    friendlyName: "Sign up button url",
    defaultValue: "#",
    showIf: 'options.get("variant") === "raf"',
    required: true,
  },
  {
    name: "registerTitle",
    type: "string",
    defaultValue: "Sign up",
    showIf: 'options.get("variant") === "raf"',
    friendlyName: "Sign up button label",
    required: true,
  },
  {
    name: "signInUrl",
    type: "url",
    defaultValue: "#",
    showIf: 'options.get("variant") === "raf"',
    friendlyName: "Sign in button url",
    required: true,
  },
  {
    name: "signInTitle",
    type: "string",
    defaultValue: "Sign in",
    showIf: 'options.get("variant") === "raf"',
    friendlyName: "Sign in button label",
    required: true,
  },
  {
    name: "stepslist",
    type: "list",
    defaultValue: [
      {
        title: "1. Send your referral code",
        text: "Copy and send the code to as many friends* as you would like!",
        details:
          "*You can find your referral code at the top of this page and in your Account Dashboard. Copy and send the code to as many friends as you’d like!</p>\r\n<h2><p> </p>\r\n</h2>\r\n",
        imgRef:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F2e31cd89122241169b42b3c4589cf643",
      },
      {
        title: "2. Receive a £20 voucher*",
        text: "You’ll get a £20 discount code (delivered to your inbox) once your friends have made their first purchase.",
        details:
          "*You will get a £20 voucher per purchase placed using your referral code.",
        imgRef:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F2e31cd89122241169b42b3c4589cf643",
        imgEx: null,
      },
    ],
    friendlyName: "Steps for Logged-In Users",
    required: true,
    subFields: [
      {
        name: "title",
        type: "string",
        friendlyName: "Step Title",
        required: true,
      },
      {
        name: "text",
        type: "string",
        friendlyName: "Step Description",
        required: true,
      },
      {
        name: "details",
        type: "richText",
        friendlyName: "Step Details",
      },
      {
        name: "imgRef",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        friendlyName: "Image for step",
        required: true,
      },
      {
        name: "imgEx",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        friendlyName: "Example Image URL",
      },
    ],
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("stepslist");
      if (Array.isArray(items) && items.length > 4) {
        options.set("stepslist", items.slice(0, 4));
        alert("You can add maximum 4 steps");
      }
    },
  },
  {
    name: "stepslistloggedout",
    type: "list",
    friendlyName: "Steps for Logged-Out Users",
    required: true,
    defaultValue: [
      {
        title: "1. Log in",
        text: 'To refer friends, you need to be logged in to your Ploom account.<br />\r\nAlready have an account? <br />\r\n<a href="a">Log in now <br />\r\n</a>Don’t have an account yet? <br />\r\n<a href="a">Create a Ploom account</a></p>\r\n',
        details: null,
        imgRef:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F2e31cd89122241169b42b3c4589cf643",
      },
      {
        title: "2. Send your referral code",
        text: "Once logged in, you can find your referral code at the top of this page and in your Account Dashboard. Copy and send the code to as many friends as you’d like!",
        details: null,
        imgRef:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F2e31cd89122241169b42b3c4589cf643",
      },
      {
        title: "3. Receive a £20 voucher*",
        text: "You’ll get a £20 discount code (delivered to your inbox) once your friends have made their first purchase.",
        details:
          "*You will get a £20 voucher per purchase placed using your referral code.",
        imgRef:
          "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F2e31cd89122241169b42b3c4589cf643",
      },
    ],
    subFields: [
      {
        name: "title",
        type: "string",
        friendlyName: "Step Title",
        required: true,
      },
      {
        name: "text",
        type: "string",
        friendlyName: "Step Description",
        required: true,
      },
      {
        name: "details",
        type: "string",
        friendlyName: "Step Details",
      },
      {
        name: "imgRef",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        friendlyName: "Image for step",
        required: true,
      },
      {
        name: "imgEx",
        type: "string",
        allowedFileTypes: IMAGE_FILE_TYPES,
        friendlyName: "Example Image URL",
      },
    ],
    onChange: (options: Map<string, unknown>) => {
      const items = options.get("stepslistloggedout");
      if (Array.isArray(items) && items.length > 4) {
        options.set("stepslistloggedout", items.slice(0, 4));
        alert("You can add maximum 4 steps");
      }
    },
  },
] as const satisfies Inputs;

export const ReferAFriendComponent: RegisteredComponent = {
  name: "ReferAFriend",
  component: dynamic(async () =>
    withValidation(
      referAFriendInputs,
      (await import("./ReferAFriend")).ReferAFriend,
      "ReferAFriend"
    )
  ),
  inputs: referAFriendInputs,
};
